import React, { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../redux/reducers';
import { Heading, Center, useToast, Text, HStack, useTheme, Box, ScrollView } from 'native-base';
import { tableIcons } from '../MaterialTableIcons'
import MaterialTable, { Column } from 'material-table';
import { useQuery } from 'react-query';
import { getSubjects, addSubject, updateSubject, deleteSubject, getSubjectsIsPublic } from '../api';
import { ISubject } from '../types/SubjectTypes';
import { useTranslation } from 'react-i18next';

const mapStateToProps = (state: RootState) => ({
  userObj: state.auth.user,
  currentRole: state.auth.currentRole,
});

const connector = connect(mapStateToProps);
type PropsType = ConnectedProps<typeof connector> & RouteComponentProps;

const SubjectManagementPage: React.FC<PropsType> = (props) => {

  const toast = useToast();
  const { t, i18n } = useTranslation();

  const publicDataRole = ['systemAdmin', 'contentProvider'];

  const { data: subjects, isLoading, isFetching, refetch } = useQuery('subjects', () => (!publicDataRole.includes(props.currentRole || '') ? getSubjects() : getSubjectsIsPublic()), {
    refetchOnWindowFocus: false,
    onError: () => {
      toast.show({
        title: 'Something went wrong',
        status: 'error',
        description: 'Cannot fetch learning unit',
      });
    },
  });

  useEffect(() => {
    setColumnObject([
      {
        title: 'ID',
        type: 'string',
        field: '_id',
        hidden: true,
      },
      {
        title: `${t('Name')}  (${t('Eng')})`,
        type: 'string',
        field: 'nameEng',
      },
      {
        title: `${t('Name')}  (${t('Chi')})`,
        type: 'string',
        field: 'nameChi'
      },
      {
        title: t('Created By'),
        type: 'string',
        field: 'updatedAt',
        render: (rowData) => {
          return (i18n.language === 'zh' && rowData.createdBy?.lastNameChi !== null && rowData.createdBy?.firstNameChi !== null ? `${rowData.createdBy?.lastNameChi} ${rowData.createdBy?.firstNameChi}` : `${rowData.createdBy?.lastNameEng} ${rowData.createdBy?.firstNameEng}`);
        },
        editable: 'never',
      },
      {
        title: t('Updated By'),
        type: 'string',
        field: 'updatedAt',
        render: (rowData) => {
          return (rowData.updatedBy === undefined ? 
            (i18n.language === 'zh' && rowData.createdBy?.lastNameChi !== null && rowData.createdBy?.firstNameChi !== null ? `${rowData.createdBy?.lastNameChi} ${rowData.createdBy?.firstNameChi}` : `${rowData.createdBy?.lastNameEng} ${rowData.createdBy?.firstNameEng}`) : 
            (i18n.language === 'zh' && rowData.updatedBy?.lastNameChi !== null && rowData.updatedBy?.firstNameChi !== null ? `${rowData.updatedBy?.lastNameChi} ${rowData.updatedBy?.firstNameChi}` : `${rowData.updatedBy?.lastNameEng} ${rowData.updatedBy?.firstNameEng}`));
        },
        editable: 'never',
      },
      {
        title: t('Created Date'),
        type: 'datetime',
        field: 'createdAt',
        editable: 'never',
      },
      {
        title: t('Updated Date'),
        type: 'datetime',
        field: 'updatedAt',
        editable: 'never',
      }
    ])

  }, [])

  //Need to define the columns in state, so that when filter is applied, and the data is refetched, the filter is kept
  //https://github.com/mbrn/material-table/issues/491#issuecomment-541011677
  const [columnObject, setColumnObject] = useState<Column<ISubject>[]>([]);

  return (
    <ScrollView paddingTop={["35px", '0']}>
      <Heading>{t('Subject Management')}</Heading>
      <Center padding='10px'>
        <MaterialTable
          icons={tableIcons}
          style={{ width: '100%' }}
          title={t("Subjects")}
          isLoading={isLoading || isFetching}
          editable={{
            onRowAdd: (props.currentRole !== 'contentProvider') ? async (newData) => {
              let newSubject = { ...newData, isPublic: (props.currentRole === 'systemAdmin') };
              const { ...newSubjectRequest } = newSubject
              console.log(newSubjectRequest)
              await addSubject(newSubjectRequest)
              refetch()
            } : undefined,
            onRowUpdate: (props.currentRole !== 'contentProvider') ? async (newData, oldData) => {
              console.log(newData)
              let newSubject = { ...newData };
              const { ...newSubjectRequest } = newSubject
              console.log(newSubjectRequest)
              await updateSubject(newSubjectRequest)
              refetch()
            } : undefined,
            onRowDelete: (props.currentRole !== 'contentProvider') ? async (oldData) => {
              await deleteSubject(oldData._id)
              refetch()
            } : undefined,
          }}
          columns={columnObject}
          data={subjects ?? []}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 25, 50],
            filtering: true,
            addRowPosition: 'first',
          }}
        />
      </Center>
    </ScrollView>
  )
}

export default withRouter(connector(SubjectManagementPage));